import React from "react";

export interface IBasicTextInput  {
    className?: string, 
    labelText: string, 
    labelIsHidden?: boolean, 
    placeholderText: string, 
    textString?: string, 
    setTextString: (text: string) => void, 
    maxLength?: number,
    isDisabled?: boolean,
    isReadOnly?: boolean
    id?: string,
    type?: string
    autofocus?:boolean
}

const BasicTextInput = ({id, className, labelText, labelIsHidden, placeholderText, textString, setTextString, maxLength, isDisabled, isReadOnly, type='text', autofocus=false}: IBasicTextInput) => {

    return (
        <div className={`basic-text-input-wrapper ${className ?? ""} `}>
            <label htmlFor={`basic-text-input-${id || ''}`} className={`${labelIsHidden ? "sr-only" : ""} basic-text-input-label`}>
                {labelText}
            </label>
         
            <input
                key={id ? `basic-text-input-${id}`: ''}
                type={type}
                id={`basic-text-input-${id || ''}`}
                className={"basic-text-input"}
                placeholder={placeholderText}
                value={textString}
                onChange={(e) => setTextString(e.target.value)}
                aria-label={labelText}
                maxLength={maxLength}
                disabled={isDisabled}
                readOnly={isReadOnly}
                autoFocus={autofocus}
            />
        </div>
    );
};

export default BasicTextInput